// src/utilidades/carritoLocal.js
// Persistencia local de la tienda pública: carrito, favoritos y la marca del
// catálogo (para la página de seguimiento). Solo localStorage del visitante:
// 0 lecturas de Firestore. Todo con try/catch: en modo privado o sin cuota la
// tienda funciona igual, solo sin recordar.

const DIAS_CARRITO = 7;
const MS_DIA = 24 * 60 * 60 * 1000;
const LIMITE_LOGO = 150000; // caracteres; un logo base64 más grande no se guarda

const leer = (clave) => {
  try { return JSON.parse(localStorage.getItem(clave) || 'null'); } catch { return null; }
};
const escribir = (clave, valor) => {
  try { localStorage.setItem(clave, JSON.stringify(valor)); return true; } catch { return false; }
};
const borrar = (clave) => { try { localStorage.removeItem(clave); } catch { /* sin almacenamiento */ } };

const claveCarrito = (gymId) => `agCarrito_${gymId}`;
const claveFavoritos = (gymId) => `agFavoritos_${gymId}`;
const claveMarca = (gymId) => `agTiendaMarca_${gymId}`;

/** Carrito guardado: { cantidades, variantes } o vacío si venció o no existe. */
export const leerCarrito = (gymId) => {
  const guardado = leer(claveCarrito(gymId));
  const vacio = { cantidades: {}, variantes: {} };
  if (!guardado || typeof guardado !== 'object') return vacio;
  if (!Number.isFinite(guardado.guardadoEn) || Date.now() - guardado.guardadoEn > DIAS_CARRITO * MS_DIA) {
    borrar(claveCarrito(gymId));
    return vacio;
  }
  const cantidades = {};
  Object.entries(guardado.cantidades || {}).forEach(([clave, n]) => {
    const limpia = Math.floor(Number(n));
    if (limpia > 0 && limpia <= 20) cantidades[clave] = limpia;
  });
  const variantes = {};
  Object.keys(cantidades).forEach((clave) => {
    const v = guardado.variantes?.[clave];
    if (v && typeof v === 'object') variantes[clave] = v;
  });
  return { cantidades, variantes };
};

export const guardarCarrito = (gymId, { cantidades = {}, variantes = {} }) => {
  if (!Object.keys(cantidades).length) { borrar(claveCarrito(gymId)); return; }
  escribir(claveCarrito(gymId), { cantidades, variantes, guardadoEn: Date.now() });
};

export const leerFavoritos = (gymId) => {
  const lista = leer(claveFavoritos(gymId));
  return new Set(Array.isArray(lista) ? lista.filter((id) => typeof id === 'string').slice(0, 200) : []);
};

export const guardarFavoritos = (gymId, favoritos) => {
  escribir(claveFavoritos(gymId), [...favoritos].slice(0, 200));
};

/** Marca del catálogo para pintar el seguimiento sin leer Firestore. */
export const guardarMarcaTienda = (gymId, catalogo) => {
  if (!catalogo) return;
  const logo = catalogo.marca?.logoBase64 || '';
  escribir(claveMarca(gymId), {
    nombre: catalogo.nombre || '',
    whatsapp: catalogo.whatsapp || '',
    colorPrimario: catalogo.marca?.colorPrimario || '',
    colorSecundario: catalogo.marca?.colorSecundario || '',
    logo: logo.length <= LIMITE_LOGO ? logo : '',
    metodosPago: Array.isArray(catalogo.metodosPago) ? catalogo.metodosPago : [],
    moneda: catalogo.moneda || 'PEN',
  });
};

export const leerMarcaTienda = (gymId) => {
  const marca = leer(claveMarca(gymId));
  return marca && typeof marca === 'object' ? marca : null;
};
